import { createApp } from 'vue'
import App from './App.vue'
import { loadAppSettings } from './runtime-config'

async function bootstrap() {
  const appSettings = await loadAppSettings()
  const app = createApp(App)

  app.provide('appSettings', appSettings)
  app.mount('#app')
}

bootstrap().catch((error) => {
  const root = document.querySelector('#app')

  root.textContent = 'Application configuration could not be loaded.'
  console.error(error)
})
